module.exports = __webpack_public_path__ + "img/4.758b89d0.png";